const getBaseUrl = () => {
  const url = new URL(window.location.href);

  return `${url.protocol}//${url.host.split('.').slice(1).join('.')}`;
};

export const getBaseAPIUrl = () => {
  return `${getBaseUrl()}/api/v1`;
};

export const getAPIUrl = (accountId) => {
  return `${getBaseAPIUrl()}/accounts/${accountId}`;
};

export function handleError(error) {
  throw error;
}

export function handleResponse(response) {
  if ([200, 201].includes(response.status)) {
    if (response.data.error) throw new Error(response.data.error);
    return response;
  }

  handleError({ message: 'Error handling API request', code: 500 });
  return null;
}

export const getApiErrorMessage = (error) => {
  const errorMessage = error?.response?.data?.error;
  return errorMessage || error.message;
};

export const getApiErrorCode = (error) => {
  const { status } = error?.response || { status: 0 };
  return status;
};

export function throwTestError() {
  throw new Error('test error');
}
